import { createRouter, createWebHistory } from "vue-router"
import MainPage from "../views/MainPage.vue"
import SettingsPage from "@/views/SettingsPage.vue"
import CompetitionsPage from "@/views/CompetitionsPage.vue"
import NotificationsPage from "@/views/NotificationsPage.vue"
import TradingPage from "@/views/TradingPage.vue"
import FinancePage from "@/views/FinancePage.vue"
import DepositComponent from "@/components/DepositComponent.vue"
import WithdrawComponent from "@/components/WithdrawComponent.vue"
import CompetitionComponent from "@/components/CompetitionComponent.vue"
import ActiveComponent from "@/components/ActiveComponent.vue"
import ActiveDepositComponent from "@/components/ActiveDepositComponent.vue"
import ActiveWithdrawComponent from "@/components/ActiveWithdrawComponent.vue"

const routes = [
  {
    path: "/",
    name: "home",
    component: MainPage,
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsPage,
  },
  {
    path: "/competitions",
    name: "competitions",
    component: CompetitionsPage,
  },
  {
    path: "/competitions/:id",
    name: "competition",
    component: CompetitionComponent,
  },
  {
    path: "/notifications",
    name: "notifications",
    component: NotificationsPage,
  },
  {
    path: "/trading",
    name: "trading",
    component: TradingPage,
  },
  {
    path: "/finance/:id",
    name: "finances",
    component: FinancePage,
  },
  {
    path: "/finance/deposit/:id",
    component: DepositComponent,
  },
  {
    path: "/finance/withdraw/:id",
    component: WithdrawComponent,
  },
  {
    path: "/active/:id",
    component: ActiveComponent,
  },
  {
    path: "/active/:id/deposit",
    component: ActiveDepositComponent,
  },
  {
    path: "/active/:id/withdraw",
    component: ActiveWithdrawComponent,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
